module.exports = __webpack_public_path__ + "img/map_basic.3696f576.jpg";